<app-card-content [border]="false" [title]="'Estruturas Organizacionais'" [icon]="'pi pi-sitemap'" [subtitle]="'Gerencie a hierarquia de estruturas e seus coordenadores'">
    <div card-header>
        <p-button label="Nova Estrutura" icon="pi pi-plus" size="small" (onClick)="novaEstrutura()" [appCan]="roleEstruturasCriar" />
    </div>

    <!-- ── Estatísticas ───────────────────────────────────────────────────── -->
    <div class="grid grid-cols-3 gap-3 mb-5">
        <div class="stat-card">
            <div class="stat-info">
                <span class="stat-rotulo">Total</span>
                <span class="stat-valor">{{ _todas().length }}</span>
            </div>
        </div>
        <div class="stat-card stat-card--success">
            <div class="stat-info">
                <span class="stat-rotulo">Ativas</span>
                <span class="stat-valor">{{ totalAtivos() }}</span>
            </div>
        </div>
        <div class="stat-card stat-card--danger">
            <div class="stat-info">
                <span class="stat-rotulo">Inativas</span>
                <span class="stat-valor">{{ totalInativos() }}</span>
            </div>
        </div>
    </div>

    <!-- ── Filtros ────────────────────────────────────────────────────────── -->
    <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
        <app-filtro-campo label="Nome, sigla, coordenador ou ID" [wide]="true" inputId="estruturas-filtro-texto">
            <input
                id="estruturas-filtro-texto"
                pInputText
                type="text"
                class="w-full"
                placeholder="Ex.: Tesouraria, TES ou 12..."
                [ngModel]="filtroTexto()"
                (ngModelChange)="filtroTexto.set($event)"
                (keyup.enter)="aplicarFiltros()"
            />
        </app-filtro-campo>
        <app-filtro-campo label="Status">
            <p-select [appendTo]="'body'" [options]="opcoesStatus" optionLabel="label" optionValue="value" [ngModel]="filtroStatus()" (ngModelChange)="filtroStatus.set($event)" placeholder="Status" styleClass="w-full" />
        </app-filtro-campo>
    </app-filtros-bar>

    <div class="flex items-center justify-end gap-3 mb-4">
        <span class="contador-label">{{ dadosFiltrados().length }} encontrados</span>
        <app-table-view-switcher [(viewMode)]="currentView" />
    </div>

    <!-- ── Vista CARDS ────────────────────────────────────────────────────── -->
    @if (currentView() === 'card') {
        @if (carregando()) {
            <div class="flex justify-center py-12">
                <i class="pi pi-spin pi-spinner text-3xl text-muted-color"></i>
            </div>
        } @else if (estruturasPaginadas().length === 0) {
            <div class="estado-vazio">
                <div class="estado-vazio-icone"><i class="pi pi-sitemap"></i></div>
                <p class="estado-vazio-titulo">Nenhuma estrutura encontrada</p>
                <p class="estado-vazio-subtitulo">
                    @if (temFiltrosAtivos) {
                        Tente ajustar os filtros aplicados.
                    } @else {
                        Crie a primeira estrutura organizacional.
                    }
                </p>
                @if (temFiltrosAtivos) {
                    <p-button label="Limpar filtros" severity="secondary" size="small" (onClick)="limparFiltros()" class="mt-2" />
                }
            </div>
        } @else {
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
                @for (item of estruturasPaginadas(); track item.id) {
                    <app-card-container class="flex flex-col h-full">
                        <div class="flex flex-col gap-3 h-full">
                            <!-- Topo: sigla + status -->
                            <div class="flex items-start justify-between gap-2 shrink-0">
                                <span class="id-tabela">#{{ item.id }}</span>
                                <p-tag [severity]="statusSeverity(item.inStatus)" [value]="statusLabel(item.inStatus)" [rounded]="true" styleClass="text-xs" />
                            </div>

                            <h3 class="descricao-titulo shrink-0">{{ item.descricao }}</h3>
                            <div class="divisor-acento shrink-0"></div>

                            <div class="grid grid-cols-2 gap-x-4 gap-y-3 flex-grow">
                                <div class="info-campo">
                                    <span class="info-rotulo">ID</span>
                                    <span class="info-valor font-mono">#{{ item.id }}</span>
                                </div>
                                <div class="info-campo">
                                    <span class="info-rotulo">Superior</span>
                                    <span class="info-valor">{{ item.nomeSuperior || 'Raiz' }}</span>
                                </div>
                                <div class="col-span-2 info-campo">
                                    <span class="info-rotulo">Coordenador</span>
                                    <div class="coordenador-linha min-h-[3.75rem]">
                                        <app-pessoa-avatar [foto]="item.avatarCoordenador" [iniciais]="iniciaisCoordenador(item)" [nome]="item.coordenador || ''" tamanho="xxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, item)" />

                                        <span class="info-valor truncate">
                                            {{ item.coordenador || 'Não definido' }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="card-rodape shrink-0 mt-auto justify-start items-center">
                                @if (item.inCompartilharProtocolo === 'S') {
                                    <span class="compartilhar-badge text-left"> <i class="pi pi-share-alt mr-1"></i>Compartilha protocolo </span>
                                }

                                <div class="ml-auto flex gap-2">
                                    <p-button icon="pi pi-pencil" [text]="true" size="small" pTooltip="Editar" (onClick)="editarEstrutura(item)" [appCan]="roleEstruturasEditar" />
                                    <p-button
                                        [icon]="item.inStatus === 'A' ? 'pi pi-ban' : 'pi pi-check-circle'"
                                        [severity]="item.inStatus === 'A' ? 'warn' : 'success'"
                                        [text]="true"
                                        size="small"
                                        [pTooltip]="item.inStatus === 'A' ? 'Inativar' : 'Ativar'"
                                        (onClick)="confirmarToggleStatus(item)"
                                        [appCan]="roleEstruturasAlterarStatus"
                                    />
                                </div>
                            </div>
                        </div>
                    </app-card-container>
                }
            </div>
        }
    }

    <!-- ── Vista TABELA ───────────────────────────────────────────────────── -->
    @if (currentView() === 'table') {
        <p-table [value]="estruturasPaginadas()" [loading]="carregando()" class="p-datatable-sm" stripedRows [rowHover]="true" [tableStyle]="{ 'min-width': '60rem' }">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="id" style="width: 70px">
                        ID
                        <p-sortIcon field="id" />
                    </th>
                    <th pSortableColumn="descricao">
                        Descrição
                        <p-sortIcon field="descricao" />
                    </th>
                    <th pSortableColumn="nomeSuperior">
                        Superior
                        <p-sortIcon field="nomeSuperior" />
                    </th>
                    <th pSortableColumn="coordenador">
                        Coordenador
                        <p-sortIcon field="coordenador" />
                    </th>
                    <th class="text-center" style="width: 100px">Status</th>
                    <th class="text-center" style="width: 110px">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="linha-tabela">
                    <td>
                        <span class="id-tabela">#{{ item.id }}</span>
                    </td>

                    <td>
                        <div class="flex flex-col gap-0.5">
                            <span class="font-semibold text-sm">{{ item.descricao }}</span>
                        </div>
                    </td>
                    <td>
                        @if (item.nomeSuperior) {
                            <div class="flex items-center gap-1.5">
                                <i class="pi pi-sitemap text-xs opacity-50"></i>
                                <span class="text-sm">{{ item.nomeSuperior }}</span>
                            </div>
                        } @else {
                            <span class="raiz-badge">Raiz</span>
                        }
                    </td>
                    <td>
                        @if (item.coordenador) {
                            <div class="flex items-center gap-1.5">
                                <app-pessoa-avatar [foto]="item.avatarCoordenador" [iniciais]="iniciaisCoordenador(item)" [nome]="item.coordenador || ''" tamanho="xxl" [clicavel]="true" (fotoSelecionada)="ampliarFoto($event, item)" />
                                <span class="text-sm">{{ item.coordenador }}</span>
                            </div>
                        } @else {
                            <span class="text-sm italic text-muted-color">Não definido</span>
                        }
                    </td>
                    <td class="text-center">
                        <p-tag [severity]="statusSeverity(item.inStatus)" [value]="statusLabel(item.inStatus)" [rounded]="true" />
                    </td>
                    <td class="text-center">
                        <div class="flex justify-center gap-1">
                            <p-button icon="pi pi-pencil" size="small" severity="secondary" [text]="true" pTooltip="Editar" tooltipPosition="top" (onClick)="editarEstrutura(item)" [appCan]="roleEstruturasEditar" />
                            <p-button
                                [icon]="item.inStatus === 'A' ? 'pi pi-ban' : 'pi pi-check-circle'"
                                size="small"
                                [severity]="item.inStatus === 'A' ? 'warn' : 'success'"
                                [text]="true"
                                [pTooltip]="item.inStatus === 'A' ? 'Inativar' : 'Ativar'"
                                tooltipPosition="top"
                                (onClick)="confirmarToggleStatus(item)"
                                [appCan]="roleEstruturasAlterarStatus"
                            />
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div class="estado-vazio">
                            <div class="estado-vazio-icone"><i class="pi pi-sitemap"></i></div>
                            <p class="estado-vazio-titulo">Nenhuma estrutura encontrada</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }

    <!-- ── Paginação compartilhada (cards + tabela) ───────────────────────── -->
    @if (dadosFiltrados().length > itensPorPagina()) {
        <p-paginator
            [rows]="itensPorPagina()"
            [totalRecords]="dadosFiltrados().length"
            [first]="primeiroItem"
            [rowsPerPageOptions]="[8, 12, 24, 48]"
            (onPageChange)="onPaginacaoMudar($event)"
            styleClass="mt-4 border-t border-surface-200 dark:border-surface-700"
        />
    }
</app-card-content>

<p-confirmDialog />

<app-estrutura-detalhe [(showDialog)]="modalDetalhe" [estrutura]="estruturaSelecionada()" [todasEstruturas]="_todas()" (salvo)="onSalvo()" />

<app-pessoa-foto-dialog [(foto)]="fotoAmpliada" [nome]="nomeFotoAmpliada()" />
